// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateAcceptsTerms(acceptsTerms: bool): ?UserInputValidationError {
  return acceptsTerms ? VALID : { id: 'must-accept-terms' };
}
